import React from 'react';
import { Box, Button, Flex, Text, Tooltip } from '@chakra-ui/react';
import { FiFileText } from 'react-icons/fi';

const WarrantyDocumentsPanel = ({
  title = 'Documentos',
  receptionLabel = 'Orden de recepción',
  serviceLabel = 'Informe de servicio',
  warrantyFinalLabel = 'Garantía finalizada',
  canPrintReception,
  canPrintService,
  canPrintWarrantyFinal = false,
  receptionDisabledReason = '',
  serviceDisabledReason = '',
  warrantyDisabledReason = '',
  onPrintReception,
  onPrintService,
  onPrintWarrantyFinal,
  printingReception = false,
  printingService = false,
  printingWarranty = false,
}) => (
  <Box mt={4} pt={4} borderTopWidth="1px" borderColor="gray.100">
    <Text fontWeight="semibold" color="gray.600" mb={3} fontSize="sm">
      {title}
    </Text>
    <Flex gap={2} flexWrap="wrap">
      <Tooltip
        label={canPrintReception ? receptionLabel : receptionDisabledReason}
        hasArrow
        placement="top"
      >
        <Box as="span" display="inline-block">
          <Button
            leftIcon={<FiFileText />}
            variant="outline"
            colorScheme="teal"
            size="sm"
            isDisabled={!canPrintReception}
            isLoading={printingReception}
            onClick={onPrintReception}
          >
            {receptionLabel}
          </Button>
        </Box>
      </Tooltip>

      <Tooltip
        label={canPrintService ? serviceLabel : serviceDisabledReason}
        hasArrow
        placement="top"
      >
        <Box as="span" display="inline-block">
          <Button
            leftIcon={<FiFileText />}
            variant="outline"
            colorScheme="blue"
            size="sm"
            isDisabled={!canPrintService}
            isLoading={printingService}
            onClick={onPrintService}
          >
            {serviceLabel}
          </Button>
        </Box>
      </Tooltip>

      {onPrintWarrantyFinal && (
        <Tooltip
          label={
            canPrintWarrantyFinal ? warrantyFinalLabel : warrantyDisabledReason
          }
          hasArrow
          placement="top"
        >
          <Box as="span" display="inline-block">
            <Button
              leftIcon={<FiFileText />}
              variant="outline"
              colorScheme="green"
              size="sm"
              isDisabled={!canPrintWarrantyFinal}
              isLoading={printingWarranty}
              onClick={onPrintWarrantyFinal}
            >
              {warrantyFinalLabel}
            </Button>
          </Box>
        </Tooltip>
      )}
    </Flex>
  </Box>
);

export default WarrantyDocumentsPanel;
